import * as R from 'ramda'
import uuidv4 from '@/utilities/uuid.js'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const irrigationItemPresenter = (irrigationItem, itemId) => {
  return {
    id: itemId,
    description: irrigationItem['description'],
    cost: irrigationItem['cost'],
    defaultQuantity: irrigationItem['defaultQuantity']
  }
}

const state = {
  irrigationItems: {}
}

const mutations = {
  LOAD_IRRIGATION_ITEMS (state, payload) {
    state.irrigationItems = payload
  },

  UPDATE_IRRIGATION_ITEM (state, { id, item }) {
    state.irrigationItems[id] = item
  },

  ADD_IRRIGATION_ITEM (state, { id, item }) {
    const items = {
      ...state.irrigationItems,
      [id]: item
    }

    state.irrigationItems = items
  },

  DELETE_IRRIGATION_ITEM (state, payload) {
    state.irrigationItems = R.omit(payload, state.irrigationItems)
  }
}

const actions = {
  updateIrrigationItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()
      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      if (getters.signedIn) {
        return api.createIrrigation(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_IRRIGATION_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        commit('ADD_IRRIGATION_ITEM', jsConn.formParams)
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' saved for this browser session'
        return Promise.resolve(jsConn)
      }
    } else {
      if (getters.signedIn) {
        return api.updateIrrigation(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            commit('UPDATE_IRRIGATION_ITEM', jsConn.formParams)
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' updated'
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.apiParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        commit('UPDATE_IRRIGATION_ITEM', jsConn.formParams)
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' updated for this browser session'
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteIrrigationItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteIrrigation(jsConn)
        .then(jsConn => {
          return successPipeline(jsConn)
        })
        .then(jsConn => {
          // delete it from any crops
          dispatch('deleteIrrigationItemFromAllCrops', jsConn)
          commit('DELETE_IRRIGATION_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Irrigation item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteIrrigationItemFromAllCrops', jsConn)
      commit('DELETE_IRRIGATION_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Irrigation item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  irrigationItems: state => state.irrigationItems,

  irrigationItemsIdList: state => {
    return Object.keys(state.irrigationItems)
  },

  irrigationItemsList: (state, getters, rootState, rootGetters) => {
    const itemsList = R.map((itemId) => {
      const item = getters.getIrrigationItemById(itemId)
      return irrigationItemPresenter(item, itemId)
    }, getters.irrigationItemsIdList)

    return itemsList
  },

  getIrrigationItemById: (state) => (id) => {
    return state.irrigationItems[id]
  }
}

const irrigationModule = {
  state,
  mutations,
  actions,
  getters
}

export default irrigationModule
